/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect, useState } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import { Card, Grid } from '@mui/material';

import '@brainhubeu/react-carousel/lib/style.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/components/explore';

import { ReactComponent as IconPromotion } from '../../assets/images/svg/promotion/icon_promocoes_active.svg';
import { ReactComponent as IconPlus } from '../../assets/images/svg/shops/icon_mais.svg';

import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { FormatPrice } from '../../helpers/utils/Formating';
import { useSignInContext } from '../../providers/use-signin';
import { useLoadingContext } from '../../providers/use-loading';
import { getStorege, saveStorege } from '../../helpers/db_storage';
import TitlePage from '../TitlePage';
import ModalConfirmFooter from '../Modal/ConfirmFooter';

const Promotion: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signData = useSignInContext();
  const { createloading } = useLoadingContext();

  const [dataPromotion, setDataPromotion] = useState<any>();
  const [dataLocation, setDataLocation] = useState<any>();
  const [openModalConfirmMajority, setOpenModalConfirmMajority] =
    useState(false);
  const [dataModalConfirmMajority, setDataModalConfirmMajority] = useState({
    title: 'Atenção',
    message:
      'Este estabelecimento contém produtos para maiores de 18 anos. Você confirma que é maior de idade?',
    idShop: '',
    idPromotion: '',
  });

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const handleListPromotion = async () => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.indexPromotions({
          nr_operacao: 19,
          idRestaurante: 0,
          dsCidade: dataLocation.dsCidade,
          idUsuario: dataUserStorage?.idUsuario
            ? dataUserStorage?.idUsuario
            : '0',
        });
      setDataPromotion(result.data);
      createloading(false);
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao buscar as promoções.');
    }
  };

  const handleOpenShop = (
    id_shop: any,
    id_promotion: any,
    flgMajority: any,
  ) => {
    if (flgMajority == 1) {
      setDataModalConfirmMajority({
        title: 'Atenção!',
        message:
          'Este estabelecimento contém produtos para maiores de 18 anos. Você confirma que é maior de idade?',
        idShop: id_shop,
        idPromotion: id_promotion,
      });
      setOpenModalConfirmMajority(true);
      return;
    }

    handleToPage(
      `/shop/detail/list/product/subcategorie/${window.btoa(
        id_shop,
      )}/${window.btoa(id_promotion)}/${window.btoa('promotion')}`,
    );
  };

  const handleGetPromotionToPage = async (
    id_promotion: any,
    id_shop: any,
    flgMajority: any,
  ) => {
    createloading(true);
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.getMenuItensShop({
          nr_operacao: 33,
          idRestaurante: id_shop,
          idPromocao: id_promotion,
        });

      saveStorege(
        '@mais/delivery/shop/request/product/promotion',
        result.data[0],
      );
      createloading(false);

      handleOpenShop(id_shop, id_promotion, flgMajority);
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao buscar a promoção');
    }
  };

  useEffect(() => {
    if (dataLocation?.dsCidade) {
      handleListPromotion();
    }
  }, [dataLocation]);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    if (dataStorage?.idMarketplace) {
      setDataLocation(dataStorage);
    }
  }, []);

  return (
    <>
      {dataPromotion?.length > 0 && (
        <Grid
          container
          item
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          padding="10px"
          className="Promotion"
        >
          <TitlePage
            Icon={IconPromotion}
            title="Promoções"
            backgroundColor="#F2F2F2"
            titleColor="#444"
            borderRadius="5px"
            margin="5px 0px"
          />
          {dataPromotion.map((item: any) => (
            <Grid
              key={item.idPromocao}
              onClick={() =>
                handleGetPromotionToPage(
                  item.idPromocao,
                  item.idRestaurante,
                  item.flgMaiorIdade,
                )
              }
              className={classeStyle.card}
            >
              <Grid marginLeft={1} width={78}>
                <img
                  className={classeStyle.img}
                  src={`${process.env.REACT_APP_API_IMG}${
                    item.dsImagem || item.dsImagemRest
                  }`}
                  alt="Banner"
                />
                <Grid container justifyContent="left">
                  <p className={classeStyle.textTagLive}>Aberto</p>
                </Grid>
              </Grid>
              <Grid
                display="block"
                className={classeStyle.gridPromotionContent}
              >
                <p
                  className={`${classeStyle.textTitleItem} ${classeStyle.textBold}`}
                >
                  {item.dsNome.substring(0, 20)}
                </p>
                <p className={classeStyle.titlePromotion}>
                  {item.dsPromocao.length >= 140
                    ? `${item.dsPromocao.substring(0, 150)}...`
                    : item.dsPromocao}
                </p>

                {item.vlNormal != '0.00' || item.vlDesconto != '0.00' ? (
                  item.vlNormal == item.vlDesconto ? (
                    <Grid className={classeStyle.gridValue}>
                      <Grid>
                        <p
                          className={classeStyle.textValeu}
                          style={{ color: '#a51713' }}
                        >
                          R$ {FormatPrice(item.vlDesconto)}
                        </p>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid className={classeStyle.gridValue}>
                      <p className={classeStyle.textValeu}>De</p>
                      <p
                        className={`${classeStyle.textValeu} ${classeStyle.textBold}`}
                      >
                        R$ {FormatPrice(item.vlNormal)}
                      </p>
                      <p className={classeStyle.textValeu}>Por</p>
                      <p
                        className={`${classeStyle.textValeu} ${classeStyle.textBold}`}
                        style={{ color: '#008000' }}
                      >
                        R$ {FormatPrice(item.vlDesconto)}
                      </p>
                    </Grid>
                  )
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}

      <ModalConfirmFooter
        isOpen={openModalConfirmMajority}
        title={dataModalConfirmMajority.title}
        message={dataModalConfirmMajority.message}
        btnNamePrimary="Sim, tenho 18+"
        btnNameSecondary="Não, voltar"
        btnCancel=""
        handleFn={async () =>
          handleOpenShop(
            dataModalConfirmMajority.idShop,
            dataModalConfirmMajority.idPromotion,
            0,
          )
        }
        handleFn2={async () => setOpenModalConfirmMajority(false)}
        onClose={() => setOpenModalConfirmMajority(false)}
      />
    </>
  );
};
export default Promotion;
